import React, { memo } from 'react';
import { graphql, useFragment } from 'react-relay';
import { Text } from '@atlaskit/primitives/compiled';
import { EmptyFieldText } from '@atlassian/jira-issue-empty-field-text/src/ui/index.tsx';
import type { readView_nativeIssueTable_LinkRelationshipTypeReadView$key } from '@atlassian/jira-relay/src/__generated__/readView_nativeIssueTable_LinkRelationshipTypeReadView.graphql';
import { capitalize } from '../utils.tsx';

export type ReadViewProps = {
	fieldRef: readView_nativeIssueTable_LinkRelationshipTypeReadView$key;
};

export const LinkRelationshipTypeReadView = memo<ReadViewProps>(({ fieldRef }) => {
	const data = useFragment<readView_nativeIssueTable_LinkRelationshipTypeReadView$key>(
		graphql`
			fragment readView_nativeIssueTable_LinkRelationshipTypeReadView on JiraIssueLinkRelationshipTypeField {
				issueLink {
					relationName
				}
			}
		`,
		fieldRef,
	);

	const relationName = data?.issueLink?.relationName;

	if (!relationName) {
		return <EmptyFieldText />;
	}

	return (
		<Text testId="native-issue-table.common.ui.issue-cells.link-relationship-type.read-view.text">
			{capitalize(relationName)}
		</Text>
	);
});
